module.exports = __webpack_public_path__ + "img/favicon_Artboard 1.877a0d70.png";